"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _searchInput = require("./searchInput.style");

var _svg = require("../../svg");

var _excluded = ["onEnter"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SearchInput = function SearchInput(props) {
  var onEnter = props.onEnter,
      htmlAttributes = _objectWithoutProperties(props, _excluded);

  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _searchInput.useStyle)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.div
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: classes.input,
    type: "text",
    placeholder: "\u062C\u0633\u062A\u062C\u0648 \u0622\u062F\u0631\u0633",
    onKeyUp: function onKeyUp(e) {
      return e.keyCode === 13 && onEnter(e.target.value);
    }
  }, htmlAttributes)), /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.span
  }, _svg.SearchIcon));
};

exports.SearchInput = SearchInput;
SearchInput.propTypes = {
  /** search input onEnter function */
  onEnter: _propTypes["default"].func
};
SearchInput.defaultProps = {
  onEnter: function onEnter(value) {}
};